// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","loaderSubtitle":"App_loaderSubtitle__CfMSe","loaderTitle":"App_loaderTitle__1VS_t"};